import * as React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Summary from "./Ops.BillerCategories.Summary";
import Billers from "./Ops.BillerCategories.Billers";
import BillerEdit from "./Ops.BillerCategories.BillerEdit";

const BillerCategories = props => (
  <Switch>
    <Route
      exact={true}
      path="/snapscan/ops/biller_categories"
      render={() => <Redirect to="/snapscan/ops/biller_categories/summary" />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/biller_categories/summary"
      render={routerProps => <Summary {...{ ...props, ...routerProps }} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/biller_categories/billers"
      render={routerProps => <Billers {...{ ...props, ...routerProps }} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/biller_categories/billers/:id"
      render={routerProps => <BillerEdit {...{ ...props, ...routerProps }} />}
    />
  </Switch>
);

export default BillerCategories;
